import { Columns, Layers, Sliders } from 'lucide-react';
import { SegmentedControl, type SegmentOption } from '@/components/ui';
import { cn } from '@/lib/cn';
import type { CompareMode } from './types';

const icon = 'w-3.5 h-3.5';
const MODES: SegmentOption<CompareMode>[] = [
  { value: 'slider', label: 'SPLIT', icon: <Sliders className={icon} />, title: 'Split slider view' },
  { value: 'side-by-side', label: 'DUAL', icon: <Columns className={icon} />, title: 'Side by side view' },
  { value: 'toggle', label: 'TOGGLE', icon: <Layers className={icon} />, title: 'Toggle before/after' },
];

export function ViewModeSwitch({
  value,
  onChange,
  large = false,
}: {
  value: CompareMode;
  onChange: (mode: CompareMode) => void;
  large?: boolean;
}) {
  return (
    <SegmentedControl
      label="Comparison view"
      options={MODES}
      value={value}
      onChange={onChange}
      className={cn(large && 'hidden sm:flex bg-slate-900/90 rounded-xl border-slate-800')}
      itemClassName={cn(large && 'text-xs rounded-lg gap-1.5')}
    />
  );
}
